type EngagementInput = { views?: number | null; likes?: number | null; comments?: number | null; shares?: number | null };

const finite = (value: number | null | undefined) => (typeof value === 'number' && Number.isFinite(value) ? value : null);

/** (likes + comments + shares) / views as a 0–1 fraction; null when views are unknown or 0, or no interaction is known. */
export function computeEngagementRate({ views, likes, comments, shares }: EngagementInput): number | null {
  const viewCount = finite(views);
  const interactions = [likes, comments, shares].map(finite).filter((value): value is number => value !== null);
  if (viewCount === null || viewCount <= 0 || interactions.length === 0) return null;
  return interactions.reduce((sum, value) => sum + value, 0) / viewCount;
}
